// THIRD-PARTY
import * as React from "react";
import { useRouter } from "next/router";

// DATA
import seoProps from "./utils/meta-data";

// UTILITIES
import HeadMetaData from "@lululemon/ecom-common/src/components/head-meta-data/head-meta-data";

import "@lululemon/ecom-common/src/components/search-widget/search-widget.scss";

import { NotFound } from "@lululemon/mwa-error-templates";
import { publicConfig } from "@lululemon/ecom-common/src/util/public-config";

import { LinkProvider } from "@lululemon/ui-library";
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";
/**
 * Error 404 Container
 *
 * Coordinate and render 404 error page.
 */

const NotFoundContainerWrapper = (props) => {
  const { pageData = {} } = props;
  const { asPath, locale } = useRouter();
  let statusCodeSlug = null;
  if (typeof window !== "undefined") {
    const match = asPath.match(/\/error\/(\d+)/);
    statusCodeSlug = Number(match ? match[1] : null);
  }
  return (
    <>
      <HeadMetaData {...seoProps} key={asPath} />
      <LinkProvider component={LinkGenerator}>
        <NotFound
          apiHost={publicConfig.apiHost}
          locale={locale}
          pageData={pageData}
          errorCode={props?.errorCode ?? statusCodeSlug}
        />
      </LinkProvider>
    </>
  );
};

export default NotFoundContainerWrapper;
